import { render, staticRenderFns } from "./dev-stat.vue?vue&type=template&id=23eb7d71&scoped=true"
import script from "./dev-stat.vue?vue&type=script&lang=js"
export * from "./dev-stat.vue?vue&type=script&lang=js"
import style0 from "./dev-stat.vue?vue&type=style&index=0&id=23eb7d71&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23eb7d71",
  null
  
)

export default component.exports